import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { login, signUp } from "../api";
import { toast } from "react-toastify";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";

const Login = () => {
  const { state } = useParams();
  // const [url, setUrl] = useState("signin");

  let url = state.toLowerCase();

  useEffect(() => {
    if (url === "signup") {
      loadCaptchaEnginge(6);
    }
  }, [url]);

  const [signUpDetails, setSignUpDetails] = useState({
    username: "",
    email: "",
    password: "",
    captcha: "",
  });
  const [signInDetails, setSignInDetails] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  // console.log(state);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpDetails({ ...signUpDetails, [name]: value });
  };

  const handleSignInDetails = (e) => {
    const { name, value } = e.target;
    setSignInDetails({ ...signInDetails, [name]: value });
  };

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (validateCaptcha(signUpDetails.captcha) === true) {
      const signup = toast.info("Signing up, Please wait", {
        autoClose: false,
      });
      try {
        let result = await signUp(
          signUpDetails.username,
          signUpDetails.email,
          signUpDetails.password
        );
        if (result.data) {
          // alert("signUp Successfull");
          toast.dismiss(signup);
          toast.success(result.data.message);
          setSignUpDetails({ username: "", email: "", password: "" });
          navigate("/login/signIn");
        } else {
          // alert(result.error.detail[0].msg);
          toast.dismiss(signup);
          toast.error(result.error.message);
        }
      } catch (e) {
        // alert(e);
        toast.dismiss(signUp);
        toast.error(e);
      }
    } else {
      toast.warn("Invalid captcha. Please try again.");
      return;
    }
  };
  useEffect(() => {
    if (localStorage.getItem("token")) {
      if (url !== "signup") {
        toast.success("Already Signed In");
      } else {
        toast.warn("Already Signed In, Please SignOut to SignUp");
      }
      navigate("/uploadfiles");
    }
  }, [url]);

  const handleSignIn = async (e) => {
    e.preventDefault();
    const signingIn = toast.info("Signing In, please wait", {
      autoClose: false,
    });
    try {
      let result = await login(signInDetails.email, signInDetails.password);
      if (result.data) {
        toast.dismiss(signingIn);
        toast.success("Signed In successfully");
        localStorage.setItem("token", result.data.message);
        navigate("/uploadfiles");
      } else {
        // alert(result.error.message);
        toast.dismiss(signingIn);
        toast.error(result.error.message);
      }
    } catch (e) {
      toast.dismiss(signingIn);
      toast.error(e);
    }
  };

  const renderScreen = () => {
    switch (url) {
      case "signin":
        return (
          <form className="flex flex-col w-full gap-3" onSubmit={handleSignIn}>
            <label className="text-666666">Email</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="email"
                placeholder="Enter your registered Email "
                value={signInDetails.email}
                name="email"
                onChange={handleSignInDetails}
                required
              ></input>
              <span className="mr-2">
                <img
                  src={process.env.PUBLIC_URL + "/images/login/mail.png"}
                  alt=""
                />
              </span>
            </div>
            <label className="mt-4 text-666666">Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="password"
                placeholder="Enter your password"
                value={signInDetails.password}
                name="password"
                onChange={handleSignInDetails}
                required
              ></input>
              <span className="mr-2">
                <img
                  src={process.env.PUBLIC_URL + "/images/login/password.png"}
                  alt=""
                />
              </span>
            </div>
            <Link
              to={"/login/forgetPassword"}
              className="text-right font-medium text-222222"
            >
              <p>Forget Password ?</p>
            </Link>
            <button
              type="submit"
              className="h-[56px] bg-F37021 text-white mt-8 rounded-[12px] font-semibold"
            >
              Login Now
            </button>
            <div className="w-full flex justify-center mt-5">
              <p>
                New to Vedas ?{" "}
                <Link to={"/login/signUp"} className="text-blue underline">
                  Sign Up
                </Link>
              </p>
            </div>
          </form>
        );

      case "signup":
        return (
          <form className="flex flex-col w-full gap-4" onSubmit={handleSignUp}>
            <label className="text-666666">Username</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="text"
                name="username"
                value={signUpDetails.username}
                onChange={handleChange}
                placeholder="Enter your username"
                required
              ></input>
            </div>
            <label className="text-666666">Email</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="email"
                name="email"
                value={signUpDetails.email}
                onChange={handleChange}
                placeholder="Enter your Email address"
                required
              ></input>
            </div>
            <label className="text-666666">Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="password"
                name="password"
                value={signUpDetails.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              ></input>
            </div>
            <div className="h-[10px] w-full flex items-center rounded-[12px] mt-2">
              <div className="flex gap-5 items-center text-black">
                <input
                  type="text"
                  name="captcha"
                  value={signUpDetails.captcha}
                  onChange={handleChange}
                  placeholder="Enter the captcha"
                  className="py-1 px-2 w-1/2 border border-[#f0c7a8] rounded-[12px]"
                  required
                ></input>
                <div className="w-1/2 text-black">
                  <LoadCanvasTemplateNoReload reloadText="reload" />
                </div>
              </div>
            </div>
            {/* <Link className="w-full mt-12" to={"/login/signIn"}> */}
            <button
              type="submit"
              className="h-[56px] w-full bg-F37021 text-white rounded-[12px] font-semibold mt-3"
            >
              Sign Up
            </button>
            {/* </Link> */}
            <div className="text-center text-666666 flex justify-center gap-1">
              <p>Already have an account?</p>
              <Link to={"/login/signin"} className="text-blue underline">
                SignIn
              </Link>
            </div>
          </form>
        );
      case "forgetpassword":
        return (
          <form className="flex flex-col w-full gap-3">
            <label className="text-666666">Email</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="email"
                placeholder="Enter your Email address"
              ></input>
            </div>
            <div className="text-center text-666666 ">
              <Link to={"/login/signin"} className="text-blue underline">
                {" "}
                Back to Signin
              </Link>
            </div>
            <button className="h-[56px] bg-F37021 text-white mt-12 rounded-[12px] font-semibold">
              Get Code
            </button>
          </form>
        );
      case "verifycode":
        return (
          <form className="flex flex-col w-full gap-3">
            <label className="text-666666">Enter Code</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="number"
                placeholder="Enter your code to verify"
              ></input>
            </div>
            <Link to={"/login/setPassword"} className="w-full  mt-12">
              <button className="h-[56px] w-full bg-F37021 text-white rounded-[12px] font-semibold">
                Verify Code
              </button>
            </Link>
          </form>
        );
      case "setpassword":
        return (
          <form className="flex flex-col w-full gap-3">
            <label className="text-666666">Set New Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="text"
                placeholder="Enter your Password"
              ></input>
            </div>
            <label className="mt-6 text-666666">Confirm New Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="text"
                placeholder="Confirm your Password"
              ></input>
            </div>
            <Link to={"/login/signIn"} className="w-full mt-10">
              <button className="h-[56px] bg-F37021 text-white w-full rounded-[12px] font-semibold">
                Set Password
              </button>
            </Link>
          </form>
        );

      default:
        return (
          <div className="w-full flex justify-center">
            <p>"Please check the URL"</p>
          </div>
        );
    }
  };

  return (
    <div className="w-full flex justify-center h-[100vh] items-center">
      <div className="2xl:container w-full h-[100vh] flex justify-center items-center">
        <div className="w-full flex justify-center items-stretch">
          <div className="w-full sm:w-[80%] max-w-[600px] lg:w-6/12 bg-loginleftbg bg-cover bg-no-repeat flex items-center justify-start py-10 flex-col gap-12 shadow-loginshadow">
            <div className="flex justify-center relative gap-7 w-full">
              <Link
                to={"/home"}
                className="absolute top-0 left-[15px] sm:left-[30px] bg-orange cursor-pointer shadow-services p-2 rounded-lg text-white hover:text-orange hover:bg-white "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="icon icon-tabler icons-tabler-filled icon-tabler-home "
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12.707 2.293l9 9c.63 .63 .184 1.707 -.707 1.707h-1v6a3 3 0 0 1 -3 3h-1v-7a3 3 0 0 0 -2.824 -2.995l-.176 -.005h-2a3 3 0 0 0 -3 3v7h-1a3 3 0 0 1 -3 -3v-6h-1c-.89 0 -1.337 -1.077 -.707 -1.707l9 -9a1 1 0 0 1 1.414 0m.293 11.707a1 1 0 0 1 1 1v7h-4v-7a1 1 0 0 1 .883 -.993l.117 -.007z" />
                </svg>
              </Link>{" "}
              <div className=" flex flex-col items-center gap-5 ">
                <div className="  w-fit flex flex-col ">
                  <Link to={"/home"}>
                    <img
                      className="h-[35px] sm:h-[40px]"
                      src={
                        process.env.PUBLIC_URL + "/images/login/headerlogo.svg"
                      }
                      alt="xpress_logo"
                    />
                  </Link>
                  <p className=" text-[8px] flex gap-1 text-black  justify-end">
                    Powered by
                    <Link target="_blank" to={"https://www.transforma.in/"}>
                      <img
                        className="h-[9px] sm:h-[10px]"
                        src={
                          process.env.PUBLIC_URL +
                          "/images/logos/Transforma.svg"
                        }
                        alt="xpress_logo"
                      />
                    </Link>
                  </p>
                </div>
                <p className="text-24 text-222222 font-semibold">
                  Check the integrity and <br /> quality of your content
                </p>
              </div>
            </div>
            <div className="flex flex-col w-11/12 sm:w-9/12 lg:w-7/12 text-left">
              {renderScreen()}
            </div>
          </div>
          <div className="w-6/12 hidden lg:flex items-stretch h-full overflow-hidden">
            <img
              className=" h-full 2xl:max-h-[735px] w-full object-cover"
              src={process.env.PUBLIC_URL + "/images/login/imageright.svg"}
              alt="img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
